






















































































































































import { Row, Col, Swipe, SwipeItem } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
import { wxChatShare } from "@/common/wechat";
import Openapp from "@/components/openApp.vue";
import moreList from "@/components/multiple/moreList.vue";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    Openapp,
    moreList
  }
})
export default class NewsMultiple extends Vue {
  @Prop()
  private imgList: any;
  @Prop()
  private imgInfo: any;
  @Prop()
  private isAcrossWidth: any;
  @Prop()
  private indexPage: any; // 当前页面的index
  @Prop()
  private imgMoreList: any; // 推荐新闻
  @Prop()
  private showMore: any; // 是否显示推荐新闻
  isAppH = false;
  private current: string | any = "";
  width = "";
  height = "";
  mounted() {
    this.width = document.body.clientHeight + "px";
    this.height = document.body.clientWidth + "px";
    this.isAppH = ZWY_CLOUD.isOpenInApp();
    this.$nextTick(() => {
      console.log("这是当前页面:" + this.indexPage);
      this.changePage();
    });
  }
  // 定位到当前页面
  changePage() {
    this.current = this.indexPage;
    const length = this.imgList.length;
    let direction = this.isAppH ? "Y" : "X";
    for (let index = 0; index < this.indexPage; index++) {
      let acrossEl = document.getElementsByClassName(
        "across"
      ) as HTMLCollection;
      let el;
      if (this.showMore) {
        el = acrossEl[length - index] as HTMLElement;
      } else {
        el = acrossEl[length - 1 - index] as HTMLElement;
      }
      console.log(el);
      el.style.transform =
        "translate" +
        direction +
        "(" +
        -(this.isAcrossWidth
          ? this.isAcrossWidth
          : document.body.clientHeight) +
        "px)";
      el.style.transitionDuration = 0 + "ms";
    }
  }
  //横屏滑动  v-touch  横屏
  // 手机横着,向左滑动
  swiperleft(i: number) {
    let acrossEl = document.getElementsByClassName("across") as HTMLCollection;
    console.log("这是向左滑动");
    console.log(i);
    if (i == 0) {
      console.log("没有最后的推荐, 最后一张图, 不给滑动");
    } else {
      let el = acrossEl[i] as HTMLElement;
      el.style.transform = "translateX(" + -this.isAcrossWidth + "px)";
      el.style.transitionDuration = 1000 + "ms";
      this.current = acrossEl.length - i;
    }
    console.log("22222hhhh" + this.current);
    this.$emit("getCurrentIndexH", this.current);
  }
  // 手机横着,向右滑动
  swiperright(i: number) {
    console.log("这是向右滑动");
    let acrossEl = document.getElementsByClassName("across") as HTMLCollection;
    console.log(i);
    if (acrossEl.length - 1 == i) {
      if (this.showMore) {
        let el = acrossEl[acrossEl.length - i] as HTMLElement;
        el.style.transform = "translateX(" + 0 + "px)";
        el.style.transitionDuration = 1000 + "ms";
        this.current = acrossEl.length - i + 2;
      } else {
        console.log("第一张图, 不给滑动");
      }
    } else {
      let el = acrossEl[i + 1] as HTMLElement;
      el.style.transform = "translateX(" + 0 + "px)";
      el.style.transitionDuration = 1000 + "ms";
      this.current = acrossEl.length - i - 2;
    }

    console.log("2222vvvv" + this.current);
    this.$emit("getCurrentIndexH", this.current);
  }
  // up 向上
  swiperup(i: number) {
    let acrossEl = document.getElementsByClassName("across") as HTMLCollection;
    console.log("这是向左滑动");
    console.log(i);
    if (i == 0) {
      console.log("没有最后的推荐, 最后一张图, 不给滑动");
    } else {
      let el = acrossEl[i] as HTMLElement;
      el.style.transform = "translateY(" + -document.body.clientHeight + "px)";
      el.style.transitionDuration = 1000 + "ms";
      this.current = acrossEl.length - i;
    }
    console.log("22222hhhh" + this.current);
    this.$emit("getCurrentIndexH", this.current);
  }
  swiperdown(i: number) {
    console.log("这是向右滑动");
    let acrossEl = document.getElementsByClassName("across") as HTMLCollection;
    console.log(i);
    if (acrossEl.length - 1 == i) {
      if (this.showMore) {
        let el = acrossEl[acrossEl.length - i] as HTMLElement;
        el.style.transform = "translateX(" + 0 + "px)";
        el.style.transitionDuration = 1000 + "ms";
        this.current = acrossEl.length - i + 2;
      } else {
        console.log("第一张图, 不给滑动");
      }
    } else {
      let el = acrossEl[i + 1] as HTMLElement;
      el.style.transform = "translateY(" + 0 + "px)";
      el.style.transitionDuration = 1000 + "ms";
      this.current = acrossEl.length - i - 2;
    }
    console.log("2222vvvv" + this.current);
    this.$emit("getCurrentIndexH", this.current);
  }
}
